<template>
  <div class="flex flex-col p-6 gap-4">
    <div>
      <div class="flex justify-between items-end">
        <base-label id="theme"
                    label="Theme"
                    tooltip="Applied visuals to your chat widget. Themes are loaded from this app when the chat connects, so saved and deployed changes are applied automatically without updating your embed script. Edit themes via Manage themes or Chat Themes in the bot settings menu."
        />
        <router-link :to="{name: ROUTE_NAMES.botTheme, params: {chatThemeId: routeChatThemeId}}"
                     class="flex items-center gap-1"
        >
          <span class="hover:underline">Manage themes</span>
          <vs-icon icon="call_made" size="1.2rem"/>
        </router-link>
      </div>
      <base-select :value="selectedThemeValue"
                   :options="themes"
                   text-attribute="name"
                   placeholder="No theme"
                   value-attribute="id"
                   class="w-full border-gray mt-1 h-10 text-black"
                   @input="selectedThemeValue = $event"
      />
    </div>

    <div class="flex items-center gap-2 mt-2">
      <base-switch :value="isTextOverrideEnabled"
                   :key="isTextOverrideEnabled"
                   id="textOverrideToggle"
                   @input="$emit('update:is-text-override-enabled', $event)"
      />
      <label for="textOverrideToggle"
             class="cursor-pointer"
             @click="$emit('update:is-text-override-enabled', !isTextOverrideEnabled)">
        Override default text
      </label>
    </div>

    <div>
      <base-label id="header"
                  label="Header text"
      >
        <template #tooltip>
          <img :src="chat_widget_header_text" alt="chat widget header text preview" class="w-48"/>
        </template>
      </base-label>
      <base-input :value="headerTextValue"
                  class="w-full border-gray mt-1 h-10"
                  :class="{'cursor-not-allowed': !isTextOverrideEnabled}"
                  :disabled="!isTextOverrideEnabled"
                  @input="headerTextValue = $event"
      />
    </div>

    <div>
      <base-label id="buttonTitle"
                  label="Launcher button text"
      >
        <template #tooltip>
          <img :src="chat_widget_launcher_text" alt="chat widget launcher button text preview" class="w-48"/>
        </template>
      </base-label>
      <base-input :value="buttonTitleValue"
                  class="w-full border-gray mt-1 h-10"
                  :class="{'cursor-not-allowed': !isTextOverrideEnabled}"
                  :disabled="!isTextOverrideEnabled"
                  @input="buttonTitleValue = $event"
      />
    </div>
  </div>
</template>

<script>
import BaseLabel from '@/components/base-components/BaseLabel.vue'
import BaseSelect from '@/components/base-components/BaseSelect.vue'
import BaseInput from '@/components/base-components/BaseInput.vue'
import ChatHeader from '@/components/settings/bot-theme/chat-widget/components/chat/ChatHeader.vue'
import chat_widget_header_text from '@/assets/images/chat_widget_header_text.png'
import chat_widget_launcher_text from '@/assets/images/chat_widget_launcher_text.png'
import chat_widget_logo from '@/assets/images/chat_widget_logo.png'
import { ROUTE_NAMES } from '@/router'
import { ITEM_IDS } from '@/utils/editor.constants'
import { isEmpty } from 'ramda'

export default {
  name: 'SettingsBotsForm',

  components: {
    ChatHeader,
    BaseInput,
    BaseSelect,
    BaseLabel
  },

  props: {
    selectedTheme: {
      type: Object,
      default: () => {}
    },
    selectedLangConfig: {
      type: Object,
      default: () => {}
    },
    isTextOverrideEnabled: {
      type: Boolean,
      default: false
    },
    themes: {
      type: Array,
      default: () => []
    }
  },

  emits: ['update:selected-theme', 'update:selected-lang-config', 'update:is-text-override-enabled'],

  data() {
    return {
      chat_widget_header_text,
      chat_widget_launcher_text,
      chat_widget_logo,
      ROUTE_NAMES
    }
  },

  computed: {
    routeChatThemeId() {
      if (isEmpty(this.themes)) {
        return ITEM_IDS.NEW
      } else if (!this.selectedThemeValue) {
        return this.themes[0].id
      } else {
        return this.selectedThemeValue
      }
    },
    selectedThemeValue: {
      get() {
        return this.selectedTheme?.id || ''
      },
      set(selectedThemeId) {
        const selectedTheme = this.themes.find(theme => theme.id === selectedThemeId)
        this.$emit('update:selected-theme', selectedTheme)
      }
    },
    headerTextValue: {
      get() {
        return this.selectedLangConfig?.welcome || ''
      },
      set(headerText) {
        this.$emit('update:selected-lang-config', {
          ...this.selectedLangConfig, welcome: headerText
        })
      }
    },
    buttonTitleValue: {
      get() {
        return this.selectedLangConfig?.buttonTitle || ''
      },
      set(buttonTitle) {
        this.$emit('update:selected-lang-config', {
          ...this.selectedLangConfig, buttonTitle
        })
      }
    }
  }
}
</script>
